import React from 'react';
import { getUsername } from 'services/auth';
import { convertBrl } from 'utility/generic';
import { convertToFloatBr } from 'utility/generic';

class Comprovante extends React.Component {
  constructor(props) {
    super(props);
    const { productList, client } =
      typeof props?.content === 'object'
        ? props?.content
        : JSON.parse(props?.content);
    this.information = props?.information;
    this.styles = {
      comprovante: {
        fontFamily: 'Arial, sans-serif',
        maxWidth: '80mm',
        margin: 'auto',
      },
      table: {
        width: '100%',
        borderCollapse: 'collapse',
      },
      produtoHeader: {
        textAlign: 'center',
        padding: '8px',
      },
      tr: {
        fontSize: '12px',
      },
      td: {
        fontSize: '12px',
      },
      tdProduct: {
        fontSize: '10px',
        textAlign: 'center',
      },
      th: {
        border: '1px solid black',
        fontSize: '12px',
      },
      signature: {
        marginTop: '44px',
        fontSize: '24px',
        textAlign: 'center',
        fontWeight: 'bold',
      },
      bibleVerse: {
        marginTop: '24px',
        fontStyle: 'italic',
        fontSize: '16px',
        textAlign: 'center',
        fontWeight: 'bold',
      },
      information: {
        fontSize: '24px',
        fontWeight: 'bold',
      },
      informationProduct: {
        fontSize: '24px',
        fontWeight: 'bold',
        display: 'flex',
        justifyContent: 'space-between',
      },
      payment: {
        fontSize: '12px',
        marginTop: '28px',
      },
    };
    this.products = productList;
    this.client = client;
  }

  render() {
    let totalGeral = 0;
    let totalGeralLiquido = 0;

    return (
      <div style={this.styles.comprovante} id='printablediv'>
        <div style={{ textAlign: 'center' }}>
          <strong style={{ fontSize: '24px' }}>DNG Entretenimento</strong>
          <div>
            <div style={{ fontSize: '20px', fontWeight: 'bold' }}>{`Vendedor: ${
              getUsername().split(' ')[0]
            }`}</div>
            <div style={{ fontSize: '24px' }}>(77) 98839-6721</div>
          </div>
        </div>

        <div style={{ marginTop: '10px' }}>
          <div>
            <div
              style={{ fontSize: '18px', fontWeight: 'bold' }}
            >{`Cliente: ${this.client.name}`}</div>
            <div
              style={{ fontSize: '16px', fontWeight: 'bold' }}
            >{`Comissão: ${this.client.commission} %`}</div>
          </div>
          <div
            style={{ ...this.styles.information, fontSize: '18px' }}
          >{`Data: ${new Date().toLocaleDateString()}`}</div>
        </div>

        {this.products.length > 0 ? (
          this.products
            .filter((product) => product.type !== 'GIFT')
            .map((product, index) => {
              const valorUnitario = convertToFloatBr(product.value);
              const quantidade = parseFloat(product.quantity);
              const valorTotalProduto = valorUnitario * quantidade;

              // Acumulando o total geral
              totalGeral += valorTotalProduto;

              const valorTotalAPagar =
                valorTotalProduto -
                (valorTotalProduto * parseFloat(this.client.commission)) / 100;

              totalGeralLiquido += valorTotalAPagar;
              return (
                <div
                  style={{
                    borderTop: '1px solid #ccc',
                    borderBottom: '1px solid #ccc',
                    padding: '5px 0',
                    marginTop: '24px',
                  }}
                  key={index}
                >
                  <div
                    style={{ ...this.styles.information, textAlign: 'center' }}
                  >
                    {`${product.name}`}
                  </div>
                  <div style={this.styles.informationProduct}>
                    <div>Quantidade: </div>
                    <div>{`${product.quantity}`}</div>
                  </div>
                  <div style={this.styles.informationProduct}>
                    <div>Valor Unitário: </div>
                    <div>{`${product.value}`}</div>
                  </div>
                  <div style={this.styles.informationProduct}>
                    <div>Valor Total: </div>
                    <div>{convertBrl(valorTotalProduto)}</div>
                  </div>
                  <div style={this.styles.informationProduct}>
                    <div>A Pagar: </div>
                    <div>{convertBrl(valorTotalAPagar)}</div>
                  </div>
                </div>
              );
            })
        ) : (
          <div
            style={{
              ...this.styles.signature,
              color: 'red',
              fontSize: '16px',
              borderTop: '1px solid #ccc',
              borderBottom: '1px solid #ccc',
              padding: '5px 0',
              marginTop: '24px',
            }}
          >
            Nenhum produto cadastrado neste comprovante, verifique o registro
            dos produtos!
          </div>
        )}

        <div
          style={{
            borderTop: '1px solid #ccc',
            borderBottom: '1px solid #ccc',
            padding: '5px 0',
            marginTop: '24px',
          }}
        >
          <div style={this.styles.informationProduct}>
            <div>Valor Total: </div>
            <div>{convertBrl(totalGeral)}</div>
          </div>

          <div style={this.styles.informationProduct}>
            <div>A Pagar: </div>
            <div>{convertBrl(totalGeralLiquido)}</div>
          </div>
        </div>

        {/* <div style={this.styles.signature}>
          Assinatura: ________________________
        </div> */}

        {/* ASSINATURA */}
        <div style={this.styles.signature}>
          Assinatura: ________________________
        </div>

        {/* TABELA DE PRÊMIOS */}
        {this.products?.filter((product) => product.type === 'GIFT').length >
          0 && (
          <div
            style={{
              padding: '5px 0',
              marginTop: '24px',
            }}
          >
            <div
              style={{
                ...this.styles.information,
                textAlign: 'center',
                marginBottom: '12px',
              }}
            >
              PRÊMIOS
            </div>

            <table
              style={{
                width: '100%',
                borderCollapse: 'collapse',
              }}
            >
              <thead>
                <tr>
                  <th
                    style={{
                      border: '1px solid #000',
                      padding: '8px',
                      fontSize: '24px',
                      fontWeight: 'bold',
                      textAlign: 'center',
                    }}
                  >
                    Quantidade
                  </th>

                  <th
                    style={{
                      border: '1px solid #000',
                      padding: '8px',
                      fontSize: '24px',
                      fontWeight: 'bold',
                      textAlign: 'center',
                    }}
                  >
                    Produto
                  </th>
                </tr>
              </thead>

              <tbody>
                {this.products
                  .filter((product) => product.type === 'GIFT')
                  .map((product, index) => (
                    <tr key={index}>
                      <td
                        style={{
                          border: '1px solid #000',
                          padding: '10px',
                          fontSize: '18px',
                          fontWeight: 'bold',
                          textAlign: 'center',
                        }}
                      >
                        {product.quantity}
                      </td>

                      <td
                        style={{
                          border: '1px solid #000',
                          padding: '10px',
                          fontSize: '18px',
                          fontWeight: 'bold',
                          textAlign: 'center',
                        }}
                      >
                        {product.name}
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        )}
        <div style={this.styles.bibleVerse}>
          "O senhor é meu pastor e nada me faltará." - Salmos 23:1
        </div>
      </div>
    );
  }
}

export default Comprovante;
